import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IObjects, IPrograms, IProgramsDictionaries, IStepOne, TError } from './types/step-one-interface'

const StepOneState = (state: RootState): IStepOne => state.stepOne

export const FormFieldsStepOne = createSelector(
    [StepOneState],
    (state): IStepOne => state,
)

export const DictionariesRegions = createSelector(
    [StepOneState],
    (state): IObjects[] => state.Dictionaries.Regions,
)
export const DictionariesPrograms = createSelector(
    [StepOneState],
    (state): IPrograms[] => state.Dictionaries.Programs,
)

export const isLoadingDictionaries = createSelector(
    [StepOneState],
    (state): boolean => state.Dictionaries.isLoadingDictionaries,
)
export const DictionariesError = createSelector(
    [StepOneState],
    (state): TError => state.Dictionaries.errorDictionaries,
)

export const ProgramsDictionariesForRegion = createSelector(
    [StepOneState],
    (state): IProgramsDictionaries => state.Programs,
)

export const DefaultId = createSelector(
    [StepOneState],
    (state): string => state.DefaultId.DefaultId,
)

export const isLoadingDefaultId = createSelector(
    [StepOneState],
    (state): boolean => state.DefaultId.isLoadingDefaultId,
)
export const DefaultIdError = createSelector(
    [StepOneState],
    (state): TError => state.DefaultId.errorDefaultId,
)

